import type { ConfluenceSubmitPromptOnPageCreateCommandProperties } from '@atlassian/rovo-content-bridge-api-commands';
import { CommandHandler } from '@atlassian/editor-rovo-bridge/command-handler';

import { log } from '../utils/aifc-logging.ts';

/**
 * Intentionally a no-op handler. The conversation assistant
 * (platform/packages/ai-mate/conversation-assistant) dispatches
 * ConfluenceSubmitPromptOnPageCreateCommand on every page-create flow.
 * Registering this handler — even though it does nothing beyond logging —
 * prevents the bridge from emitting METHOD_NOT_FOUND errors and failed-command
 * instrumentation events on the sender side.
 *
 * If the bridge ever supports unhandled commands gracefully (or the assistant
 * stops dispatching this command), this handler and its registration in
 * useEditorRovoBridgeCommandListener can be removed.
 */
export class SubmitPromptCommandHandler extends CommandHandler<
	ConfluenceSubmitPromptOnPageCreateCommandProperties,
	void
> {
	async execute(_payload: ConfluenceSubmitPromptOnPageCreateCommandProperties): Promise<void> {
		log('handle confluence-prompt-submit-on-page-create-command');
	}
}
